







import Vue from 'vue'

export default Vue.extend({
  props: {
    ratio: {
      type: Number,
      default: 1,
    },
  },
})
